import { CustomerSapExportSearchBody } from "@/common/api/customer-sap-export/use-customer-sap-export-search.query";

/**
 * Whether a SAP export search is narrowed down by at least one filter or a free-text search.
 * Mirrors the backend rule for `POST /customer-sap-export/re-export`, which rejects an
 * unrestricted "re-export every customer" request.
 */
export function hasCustomerSapExportSearchCriteria(
  body: CustomerSapExportSearchBody | undefined,
  search: string | undefined,
): boolean {
  if (search?.trim()) {
    return true;
  }

  return Object.values(body ?? {}).some((value) => {
    if (value === undefined || value === null) return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "string") return value.trim().length > 0;
    return true;
  });
}
